// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"245b745d","94":"fd151405","132":"eedf76ab","353":"4bda4a2c","391":"5c5346a5","406":"8d2c0c5c","421":"054d3066","430":"964369d5","479":"6db59dea","588":"94c22744","631":"49cde22f","657":"47870508","934":"1e3ed1fe"}[chunkId] + ".chunk.js";
};